// Module
var code = "<react-component name=\"MergeContactError\"></react-component>\n";
// Exports
module.exports = code;